export default __webpack_public_path__ + "static/media/CNP-Settle-Reverse.467ea3e2.yaml";